import { actionTypes } from "../constants/action-type";
//create readucer
//reducer will always take initial state and action
//first reducer
const initialState = {
  products: [],
};

export const productReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_PRODUCTS:
      return { ...state, products: payload };
      case actionTypes.FETCH_PRODUCTS:
      return { ...state, products: payload };
    default:
      return state;
  }
};

export const selectedProductReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.SELECTED_PRODUCT:
      return { ...state, ...payload };
      case actionTypes.REMOVE_SELECTED_PRODUCT:
        return {};
    default:
      return state;
  }
};
